import React from 'react';

const FwEdit = ({ color = 'currentColor', fontSize = '16px', classNameIcon = '' }) => {
  return <i className={`${classNameIcon} fas fa-edit`} style={{ color, fontSize: fontSize }}></i>;
};

export default FwEdit;
